import { computed, isRef } from 'vue'
// eslint-disable-next-line no-restricted-imports
import { useApolloClient, useQuery, useLazyQuery, useMutation } from '@vue/apollo-composable'
import { getApolloClientID } from '@/apollo/apollo-client.js'

function resolveReactiveValue(value) {
  if (typeof value === 'function') {
    return value()
  }

  if (isRef(value)) {
    return value.value
  }

  return value
}

function normalizeOptions(options) {
  if (isRef(options)) {
    return options
  }

  if (typeof options === 'function') {
    return options
  }

  return { ...options }
}

function mergeOptions(document, options) {
  return computed(() => {
    const resolvedOptions = resolveReactiveValue(options)
    const resolvedDocument = resolveReactiveValue(document)

    return {
      ...resolvedOptions,
      clientId: getApolloClientID(resolvedDocument),
    }
  })
}

export function useQueryApp(document, variables = null, options = {}) {
  const normalized = normalizeOptions(options)
  return useQuery(document, variables, mergeOptions(document, normalized))
}

export function queryApp(document, variables = null, options = {}) {
  const { resolveClient } = useApolloClient()
  const client = resolveClient(getApolloClientID(document))
  return client.query({ query: document, variables, ...options })
}

export function refetchQueriesApp(document, include) {
  const { resolveClient } = useApolloClient()
  const client = resolveClient(getApolloClientID(document))
  return client.refetchQueries({ include })
}

export function useLazyQueryApp(document, variables = null, options = {}) {
  const normalized = normalizeOptions(options)
  return useLazyQuery(document, variables, mergeOptions(document, normalized))
}

export function useMutationApp(document, options = {}) {
  const normalized = normalizeOptions(options)
  return useMutation(document, mergeOptions(document, normalized))
}
